.sendto-panel {
  .context-help-description {
    position: absolute;
    top: 40px;
    right: 50px;
  }

  .table {
    td.selection {
      padding: 0 0 0 5px;
      width: 1%;
      vertical-align: middle;
    }

    td.committee {
      width: 40%;
      vertical-align: middle;
    }

    td.meeting {
      width: 59%;

      .k-combobox {
        margin: 6px 0 0 0;
        width: 100%;
      }
    }
  }
}
